import React, {Component} from 'react';

class IconDoorOpened extends Component {
  render() {
    const {color, size} = this.props;
    const h = size === "lg"
      ? 128
      : 48;
    const w = size === "lg"
      ? 128
      : 48;
      return (
        <i className="emoji">
          <svg style={{fill: color}} className="emoji" viewBox="-8 -8 64 64" height={h} width={w}  xmlns="http://www.w3.org/2000/svg">
          <path d="M 26.78125 0 C 26.75 0.0078125 26.71875 0.0195313 26.6875 0.03125 L 10.6875 5.03125 C 10.269531 5.167969 9.992188 5.5625 10 6 L 10 46 C 10 46.457031 10.308594 46.855469 10.75 46.96875 L 26.75 50.96875 C 27.050781 51.046875 27.367188 50.980469 27.613281 50.789063 C 27.855469 50.601563 28 50.308594 28 50 L 28 1 C 28.003906 0.710938 27.878906 0.4375 27.664063 0.246094 C 27.449219 0.0546875 27.160156 -0.0351563 26.875 0 C 26.84375 0 26.8125 0 26.78125 0 Z M 26 2.375 L 26 48.71875 L 12 45.21875 L 12 6.75 Z M 30 4 L 30 6 L 38 6 L 38 45 L 30 45 L 30 47 L 39 47 C 39.550781 47 40 46.550781 40 46 L 40 5 C 40 4.449219 39.550781 4 39 4 Z M 24 24 C 23.449219 24 23 24.671875 23 25.5 C 23 26.328125 23.449219 27 24 27 C 24.550781 27 25 26.328125 25 25.5 C 25 24.671875 24.550781 24 24 24 Z "/>
        </svg>
      </i>
    )
  }
};

export default IconDoorOpened;



// WEBPACK FOOTER //
// ./src/style/icon/IconDoorOpened.js